import { useQuery } from 'react-query';
import { useChannelDao } from 'shared/dao/channelDao';
import { IChannelRequestPayload, IChannelResponsePayload } from 'shared/interfaces/IChannel';

export const useChannelService = () => {
  const {
    getChannel: getChannelDao,
    getChannelSearch: getChannelSearchDao,
    getSingleChannel: getSingleChannelDao,
  } = useChannelDao();

  const getChannel = (payload?: IChannelRequestPayload) => {
    const { isLoading, isError, error, data, isFetching, isPreviousData } = useQuery<IChannelResponsePayload, Error>(
      ['channel', payload],
      () => getChannelDao(payload),
    );

    return {
      data,
      error,
      isLoading,
      isError,
      isFetching,
      isPreviousData,
    };
  };

  // new add
  const getStation = (payload?: IChannelRequestPayload) => {
    const { isLoading, isError, error, data, isFetching, isPreviousData } = useQuery<IChannelResponsePayload, Error>(
      ['station', payload],
      () => getChannelDao(payload),
    );

    return {
      data,
      error,
      isLoading,
      isError,
      isFetching,
      isPreviousData,
    };
  };

  // FOR FILTER SEARCH AND CREATE NEW CHANNEL
  const getChannelSearch = (payload?: IChannelRequestPayload) => {
    const { isLoading, isError, error, data, isFetching, isPreviousData } = useQuery<IChannelResponsePayload, Error>(
      ['channel', payload],
      () => getChannelSearchDao(payload),
    );

    return {
      data,
      error,
      isLoading,
      isError,
      isFetching,
      isPreviousData,
    };
  };

  const getSingleChannel = (id?: string) => {
    const { isLoading, isError, error, data, isFetching, isPreviousData } = useQuery<IChannelResponsePayload, Error>(
      ['channel', id],
      () => getSingleChannelDao(id || ''),
      { enabled: !!id },
    );

    return {
      data: data?.data,
      // data: data,
      error,
      isLoading,
      isError,
      isFetching,
      isPreviousData,
    };
  };

  return {
    getChannel,
    getSingleChannel,
    getStation,
    getChannelSearch,
  };
};
